

import { useState } from "react";
import Config from "../../../Config";
import Received from "../../msg/Revived";
import Sended from "../../msg/Sended";
import NewMsg from "./NewMsg";
 

 

function MsgView(props)
{

    const [msg_option, setMsgOption] = useState(null);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);  
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
  
 

    if(props.mainView.viewSelected == "received") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "sended")   tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "new")      tab3 = tab3 + " selected";
 
 

    var subMenu = <div className="submenu">
            <div className={tab3} module="msg" view="new" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mNew} </div>   
            <div className={tab2} module="msg" view="sended" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mSended} </div> 
            <div className={tab1} module="msg" view="received" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mReceived} </div>                                               
    </div>
 


    if(msg_option == null)
    {
        setMsgOption([]);

        props.mainView.setProgress(-2);

                    
                        fetch( Config.url + '/rest_v1_msg,msg_option', {  
                            method: 'POST', 
                            body: JSON.stringify([]), 
                            headers: {
                                'Content-Type': 'application/json',                    
                                'X-Api-Key': props.userData.apiKey,
                                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                                '_p_dziecko_id_': props.userData.p_dziecko_id,
                                '_sec_key_': Config.genXKey() ,
                            }
                        })         
                        .then(res => res.json() )
                        .then(res => { 

                                    props.mainView.setProgress(-1);        
                                    if(res._sys_ == undefined)
                                    {
                                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                                    }else
                                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                                    {
                                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                                    }else    
                                    {
                                        props.mainView.setProgress(-1);  
                                        if(res.status == 'OK') {
                                                
                                            setMsgOption(res.result);
                                        } 

                                    }
                        } )
                        .catch(err => {          
                                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                                    props.mainView.setProgress(-1);
                        });

        
    }
 

    if(msg_option == null || msg_option.access == undefined)
    {
        return <div>
            ...
        </div>
    }


    if(msg_option != null && msg_option.access == 0)
    {
       
        return   <div className="econtent ">          
                    Brak uprawnień do tej części systemu.
        </div>
    }


    if(props.mainView.viewSelected == 'received')
    {
        document.title =  props.userData.dic.forParents  + " / "  + props.userData.dic.mReceived; 
         

        return (
            <div className="econtent ">                           
          
                   {subMenu} 
                    <Received  userData={props.userData}  mainView={props.mainView}  />                  
             </div>
        )
    }


    if(props.mainView.viewSelected == 'sended')
        {
            document.title = props.userData.dic.forParents  + " / "  + props.userData.dic.mReceived; 
    
            return (
                <div className="econtent ">                           
              
                       {subMenu} 
                        <Sended  userData={props.userData}  mainView={props.mainView}  />                  
                 </div>
            )
        }

            

        if(props.mainView.viewSelected == 'new')
            {
                document.title = props.userData.dic.forParents  + " / "  + props.userData.dic.mNew; 
        
                return (
                    <div className="econtent ">                           
                  
                           {subMenu} 
                            <NewMsg  userData={props.userData}  mainView={props.mainView}  />                  
                     </div>
                )
            }


    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default MsgView ;